import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { useFormContext } from 'react-hook-form'
import { Trash2, Undo2 } from 'lucide-react'
import WishLegacyPriority from 'app/frontend/types/custom/WishLegacyPriority'
import WishLegacyPriorityDot from 'app/frontend/base/components/WishLegacyPriorityDot'
import { defaultWishLabels } from '../../TeamLoot/helpers'
import Card from 'app/frontend/base/components/Card'

const priorities: WishLegacyPriority[] = ['huge', 'big', 'small', 'tiny']

const settingName = (priority: WishLegacyPriority) =>
  `wishlistLabel${priority.charAt(0).toUpperCase()}${priority.slice(1)}`

const WishlistPriorityLabelFields = () => {
  const { watch, setValue } = useFormContext()
  const allowed = (watch('settings.wishlistAllowedLabels')?.value ??
    []) as string[]

  const toggle = (priority: WishLegacyPriority) => {
    const next = allowed.includes(priority)
      ? allowed.filter((entry) => entry !== priority)
      : [...allowed, priority]
    setValue('settings.wishlistAllowedLabels.value', next, {
      shouldDirty: true,
    })
  }

  return (
    <div className='grid gap-2 grid-cols-2 sm:grid-cols-4 mb-6'>
      {priorities.map((priority) => {
        const name = settingName(priority)
        const setting: wowaudit.Setting<string> = watch(`settings.${name}`)
        const isAllowed = allowed.includes(priority)

        return (
          <Card
            key={priority}
            className={`flex items-center gap-2 ${
              isAllowed ? '' : 'opacity-50'
            }`}
          >
            <WishLegacyPriorityDot priority={priority} />
            <Input
              value={setting?.value ?? ''}
              placeholder={defaultWishLabels[priority]}
              onChange={(event) =>
                setValue(`settings.${name}.value`, event.target.value, {
                  shouldDirty: true,
                })
              }
            />
            <Button
              type='button'
              variant='outline'
              size='sm'
              className='shrink-0 px-2'
              onClick={() => toggle(priority)}
            >
              {isAllowed ? <Trash2 size={16} /> : <Undo2 size={16} />}
            </Button>
          </Card>
        )
      })}
    </div>
  )
}

export default WishlistPriorityLabelFields
